import "./Collection.module.css";
import Header from "@/reusable_sections/Header";
import BrowseOurSilhouettes from "./sections/BrowseOurSilhouettes";
import CustomizationOptions from "./sections/CustomizationOptions";
import FooterInformation from "@/reusable_sections/Footer";
export default function CollectionPage() {
  return <div>
      <Header />
      <BrowseOurSilhouettes />
      <CustomizationOptions />
      <FooterInformation />
    </div>;
}